import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const FileCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6px;
  padding: 8px;
  max-width: 110px;
`;

export const Thumbnail = styled.div`
  display: flex;
  margin-right: -12px;
`;

export const ThumbnailIcon = styled.div<{ loadingState?: boolean }>`
  width: 90px;
  height: 60px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.loadingState
      ? props.theme.atlas.semantic.color.type.muted
      : props.theme.atlas.semantic.color.type.default};
`;

export const ThumbnailImage = styled.img`
  max-width: 90px;
  max-height: 60px;
  object-fit: cover;
  border-radius: 3px;
`;

export const CrossIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-left: -12px;
  margin-top: -12px;
  border: none;
  cursor: pointer;
`;

export const FileName = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  max-width: 90px;
  display: flex;
`;

export const FileNameSpan = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const FileSize = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
`;

export const FileDetails = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 90px;
`;
